import { create } from "zustand";
import axios from "axios";
import toast from "react-hot-toast";

const API_BASE = "https://kz-appointments-api.onrender.com/api";

export const useAppointmentStore = create((set, get) => ({
  // --- States ---
  appointments: [],
  workingHours: null,
  holidays: [],
  isLoading: false,
  selectedAppointment: null,
  toastOpen: false,
  doctorId: null,
  schedule: {},

  // --- Appointments ---
  getAppointments: async () => {
    set({ isLoading: true });
    try {
      const res = await axios.get(`${API_BASE}/appointments`);
      set({ appointments: res.data });
    } catch (err) {
      toast.error("Failed to fetch appointments");
    } finally {
      set({ isLoading: false });
    }
  },

  getSchedule: async () => {
    set({ isLoading: true });
    try {
      const res = await axios.get(
        `${API_BASE}/doctors/${get().doctorId}/schedule`
      );
      console.log(res.data);
      set({ schedule: res.data });
    } catch (err) {
      toast.error("Failed to fetch schedule");
    } finally {
      set({ isLoading: false });
    }
  },

  createAppointment: async (data) => {
    try {
      const res = await axios.post(`${API_BASE}/appointments/patient`, data);
      set({ appointments: [...get().appointments, res.data] });
      toast.success("Appointment created!");
    } catch (err) {
      toast.error("Failed to create appointment");
    }
  },

  updateAppointment: async (id, data) => {
    try {
      const res = await axios.put(`${API_BASE}/appointments/${id}`, data);
      set({
        appointments: get().appointments.map((a) =>
          a._id === id ? res.data : a
        ),
      });
      toast.success("Appointment updated!");
    } catch (err) {
      toast.error("Failed to update appointment");
    }
  },

  deleteAppointment: async (id) => {
    try {
      await axios.delete(`${API_BASE}/appointments/${id}`);
      set({
        appointments: get().appointments.filter((a) => a._id !== id),
      });
      toast.success("Appointment deleted");
    } catch (err) {
      toast.error("Failed to delete appointment");
    }
  },

  // --- Doctor Working Hours ---
  getWorkingHours: async (doctorId) => {
    try {
      const res = await axios.get(`${API_BASE}/doctors/${doctorId}/hours`);
      set({ workingHours: res.data });
    } catch (err) {
      toast.error("Failed to load working hours");
    }
  },

  setWorkingHours: async (doctorName, data) => {
    try {
      console.log({
        doctorName,
        ...data,
      });
      const doctorId = get().doctorId;
      const res = await axios.post(`${API_BASE}/doctors/${doctorId}/schedule`, {
        doctorName,
        ...data,
      });
      set({ workingHours: res.data });
      set({ toastOpen: true });
      toast.success("Working hours updated!");
    } catch (err) {
      toast.error("Failed to update working hours");
    }
  },

  // --- Holidays / Off Days ---
  getHolidays: async (doctorId) => {
    try {
      const res = await axios.get(`${API_BASE}/doctors/${doctorId}/holidays`);
      set({ holidays: res.data });
    } catch (err) {
      toast.error("Failed to fetch holidays");
    }
  },

  addHoliday: async (doctorId, date) => {
    try {
      const res = await axios.post(`${API_BASE}/doctors/${doctorId}/holidays`, {
        date,
      });
      set({ holidays: [...get().holidays, res.data] });
      toast.success("Holiday added!");
    } catch (err) {
      toast.error("Failed to add holiday");
    }
  },

  removeHoliday: async (doctorId, dateId) => {
    try {
      await axios.delete(`${API_BASE}/doctors/${doctorId}/holidays/${dateId}`);
      set({ holidays: get().holidays.filter((h) => h._id !== dateId) });
      toast.success("Holiday removed");
    } catch (err) {
      toast.error("Failed to remove holiday");
    }
  },

  // --- Appointment Selection ---
  setSelectedAppointment: (appointment) =>
    set({ selectedAppointment: appointment }),
  setToastOpen: (open) => set({ toastOpen: open }),
  setDoctorId: (id) => set({ doctorId: id }),
}));
